import React, { Component } from "react";
import NavTab from '../../../components/common/global_layout/navTab'
import { Container, Row} from "reactstrap";
import AdvancedSearchLocation from '../../../components/common/Cars/advancedSearchLocation'
import Footer from '../../../components/common/global_layout/footer'
import CarType from '../../../components/common/Cars/CarType'
import { NavLink } from "react-router-dom";
import  { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CarCard from "../../../components/common/Cars/carCard";
import httpClient from "../../../httpClient";
import PagePath from "../../../components/common/pagePath";


class Location extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedAnnounces : [],
      hostName : process.env.REACT_APP_SERVER_URL,
    }
  }

  async componentDidMount(){
    const searchedAnnounces = await httpClient.getAllCarsLocation()
    this.setState({
      searchedAnnounces : searchedAnnounces
    })
    console.log(searchedAnnounces);
  }
    render() { 
      const ann = this.state.searchedAnnounces.map(elm=>{
        return (                 
        <div className="col-6 col-md-3 mb-2 mt-2 px-1 p-sm-2">
        <CarCard
          className="typeCard"
          nbrPerson ={elm.nbrSiege}
          nbrPorte = {elm.nbrPortes}
          AC = {true}
          energie = {elm.energie}
          img={`${this.state.hostName}/api/announces/${elm.photos[0]}/avatar/0`}
          name={elm.title}
          price={elm.parJrs.prix + " " + elm.parJrs.currancy}
          carLink={`/cars/${elm._id}/carDetails`}
        />
      </div>)
      })
        return (
          <>
            <NavTab />
            <Container>
              <PagePath 
              pages={["Ghurfaty","Véhicule","Location"] }
              links={["/home","/cars","/cars/location"]}
              />
              <AdvancedSearchLocation />

              <CarType />
              <div className="row typesCont d-flex justify-content-start ">
                  {ann}
              </div>
            </Container>
            <Footer />
          </>
        );
    }
}



  
  //connect function INJECTS dispatch function as a prop!!
  export default Location;

